import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class NavigationSelection extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            activeTab: props.activeTab || 'stats'
        };
    }

    render() {
        const entries = this.props.entries.map((entry, i) => {
            const Div = styled.div`
            background-image: url(${entry.url})`;

            return (
                <Div
                    key={entry.key}
                    onClick={() => {
                        if (!window.loginController.loggedIn && entry.key !== 'twitch-client') {
                            alert(`You need to login first to access ${entry.key}`);

                            return;
                        }

                        this.setState({
                            activeTab: entry.key
                        })
                        this.props.callback(entry.key);
                    }}
                    className={"mb-control-option" + (this.state.activeTab === entry.key ? ' active' : '')}
                />
            );
        })

        return (
            <div className="mb-control">
                {entries}
            </div>
        )
    }
}

NavigationSelection.propTypes = {
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            key: PropTypes.string.isRequired    
        }
    )).isRequired,
    activeTab: PropTypes.string,
    callback: PropTypes.func.isRequired
};

export default NavigationSelection; // Don’t forget to use export default!


// WEBPACK FOOTER //
// ./src/NavigationSelection.js